export const initialFormValues = {
  email: '',
} as const

export const VERIFICATION_ATTEMPTS_ERROR_CODE = 'VerificationAttemptsExceeded'
